 import { SetEstimatedRoute } from "../../../Redux/actions/actionNames";
const workerUrl = new URL('./test.worker.js', import.meta.url);

export const EstimateRouteWorker = (dispatch ,data) => {
  const worker = new Worker(workerUrl);
  worker.postMessage(JSON.stringify(data))
  worker.addEventListener("message", (event) => {
    dispatch(SetEstimatedRoute({ waypoints: event.data }));
    worker.terminate();
  });
};
